import Box from '@mui/material/Box';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import logo13 from './images/Logo_13.jpeg';
import logo17 from './images/Logo_17.jpeg';
import logo28 from './images/Logo_28.jpeg';
import logo33 from './images/Logo_33.jpeg';
import logo6 from './images/Logo_6.jpeg';
import image1 from './images/login_1.jpg';
import image2 from './images/login_2.jpg';

const images = [image1, image2, logo6, logo13, logo17, logo28, logo33];
// randomize order of images so a different one is first each time
images.sort(() => Math.random() - 0.5);

const ImageCarousel: React.FC = () => {
  const items = images.map((image, idx) => <Image key={idx} image={image} />);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
      }}
    >
      <Slider
        speed={750}
        infinite
        autoplay
        autoplaySpeed={3000}
        slidesToShow={1}
        slidesToScroll={1}
        pauseOnHover={false}
        arrows={false}
      >
        {items}
      </Slider>
    </Box>
  );
};

export default ImageCarousel;

interface Props {
  image: string;
}

const Image: React.FC<Props> = ({ image }) => {
  return (
    <Box
      component='img'
      src={image}
      alt='Login art'
      sx={{ height: '100vh', width: '100%', objectFit: 'cover' }}
    />
  );
};
